__turbopack_context__.v({
  "card": "ProductCard-module-scss-module__gX1Bpa__card",
  "card__body": "ProductCard-module-scss-module__gX1Bpa__card__body",
  "card__cta": "ProductCard-module-scss-module__gX1Bpa__card__cta",
  "card__details": "ProductCard-module-scss-module__gX1Bpa__card__details",
  "card__image": "ProductCard-module-scss-module__gX1Bpa__card__image",
  "card__image-link": "ProductCard-module-scss-module__gX1Bpa__card__image-link",
  "card__price": "ProductCard-module-scss-module__gX1Bpa__card__price",
  "card__title": "ProductCard-module-scss-module__gX1Bpa__card__title",
});
